import React from 'react';
import { Search, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Sel } from './shared';

const STATUS = [['', 'All statuses'], ['paid', 'Paid'], ['processing,needs_review', 'Processing'], ['initiated,pending', 'Pending'],
  ['failed', 'Failed'], ['cancelled,voided', 'Cancelled / voided'], ['refunded,partially_refunded', 'Refunded'], ['disputed', 'Disputed']];
const GATEWAY = [['', 'All methods'], ['plugnpay', "Card (Plug'n Pay)"], ['paypal', 'PayPal']];
const PRODUCT = [['', 'All products'], ['pro_monthly', 'Pro Monthly'], ['pro_annual', 'Pro Annual'], ['officials_annual', 'Officials Scheduling'], ['bundle_annual', 'Pro + Officials Bundle'], ['bundle_flex', 'Pro + Officials (Flexible)']];
export const EMPTY_FILTERS = { q: '', status: '', gateway: '', product: '', since: '', until: '' };

export const TransactionFilters = ({ f, setF, onExport }) => {
  const set = (k) => (v) => setF((x) => ({ ...x, [k]: v }));
  return (
    <div className="flex flex-wrap gap-3 items-end" data-testid="sales-filters">
      <div className="flex-1 min-w-[200px]">
        <Label className="text-xs">Search</Label>
        <div className="relative">
          <Search className="w-4 h-4 absolute left-2 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input value={f.q} onChange={(e) => set('q')(e.target.value)} placeholder="Email, name, order id, receipt #" className="pl-8" data-testid="sales-search" />
        </div>
      </div>
      <div><Label className="text-xs">Status</Label><Sel value={f.status} onChange={set('status')} options={STATUS} testId="sales-status-filter" className="block" /></div>
      <div><Label className="text-xs">Method</Label><Sel value={f.gateway} onChange={set('gateway')} options={GATEWAY} testId="sales-gateway-filter" className="block" /></div>
      <div><Label className="text-xs">Product</Label><Sel value={f.product} onChange={set('product')} options={PRODUCT} testId="sales-plan-filter" className="block" /></div>
      <div><Label className="text-xs">Since</Label><Input type="date" value={f.since} onChange={(e) => set('since')(e.target.value)} className="w-40" data-testid="sales-since-filter" /></div>
      <div><Label className="text-xs">Until</Label><Input type="date" value={f.until} onChange={(e) => set('until')(e.target.value)} className="w-40" data-testid="sales-until-filter" /></div>
      <Button variant="outline" onClick={() => setF(EMPTY_FILTERS)} data-testid="sales-clear-filters">Clear</Button>
      <Button onClick={onExport} className="bg-[#00247D] hover:bg-[#001A5C]" data-testid="sales-export-csv"><Download className="w-4 h-4 mr-1" />Export CSV</Button>
    </div>
  );
};
